export const LANGS = [
  { code: "it", label: "Italiano", short: "IT" },
  { code: "en", label: "English", short: "EN" },
  { code: "de", label: "Deutsch", short: "DE" },
];

const it = {
  meta: { title: "Hammer Gym Studios Lugano — Old School Bodybuilding Gym dal 2011" },
  nav: { gym: "La palestra", equipment: "Attrezzatura", gallery: "Galleria", pricing: "Prezzi", contact: "Contatti", trial: "Prova gratuita", menu: "Menu" },
  hero: {
    eyebrow: "Hammer Gym Studios — Lugano",
    title: ["Old School", "Bodybuilding", "Gym."],
    sub: "Ghisa, sudore e macchine Hammer Strength. Dal 2011 a Lugano si allena chi fa sul serio. Niente fronzoli: solo tu, il ferro e la prossima ripetizione.",
    ctaTrial: "Prenota la prova gratuita",
    ctaPrices: "Vedi i prezzi",
    stamp: "EST. 2011 • VIA FOLA 13 • LUGANO • OLD SCHOOL • ",
    scroll: "Scorri",
    scribble: "niente scuse.",
  },
  strip: { hoursLabel: "Orari", hours: "Lun–Dom · 06:00–22:00", addressLabel: "Indirizzo", callLabel: "Telefono", igLabel: "Instagram", openNow: "Aperto ora", closedNow: "Chiuso ora" },
  band: ["NESSUNA SCUSA", "OLD SCHOOL", "EST. 2011", "LIGHT WEIGHT, BABY!", "FERRO VERO", "LUGANO"],
  about: {
    kicker: "Cap. 01 — La palestra",
    title: "Qui non si viene a farsi vedere. Si viene a crescere.",
    p1: "Hammer Gym Studios nasce nel 2011 come palestra di bodybuilding vecchio stampo: niente specchi da selfie, niente abbonamenti complicati, niente scorciatoie. Solo attrezzatura seria e gente che si allena sul serio.",
    p2: "Siamo la casa del ferro di Lugano, sotto lo stesso tetto di CrossFit Lugano ma con un'anima tutta nostra: quella della Golden Era. Principiante o atleta da gara, qui trovi spazio, rispetto e qualcuno pronto a darti una mano sull'ultima ripetizione.",
    stats: ["Anno di fondazione", "Giorni su 7", "Ore al giorno"],
    note: "Via Fola 13 — la nostra seconda casa",
    quote: "Sono le ultime tre o quattro ripetizioni a far crescere il muscolo.",
    quoteBy: "Arnold Schwarzenegger",
    prompt: "Oggi pesante. Domani più pesante.",
  },
  equipment: {
    kicker: "Cap. 02 — Attrezzatura",
    title: "Official Hammer Strength Training Center",
    intro: "Le macchine plate-loaded che hanno fatto la storia del bodybuilding. Movimenti naturali, carichi veri, nessuna scorciatoia.",
    items: [
      { t: "Hammer Strength plate-loaded", d: "Spinte, trazioni, gambe: le macchine rosse che conosci dalle palestre leggendarie." },
      { t: "Pesi liberi", d: "Manubri, bilancieri, dischi e panche. La base di tutto, da sempre." },
      { t: "Rack e area forza", d: "Squat, panca, stacchi. Spazio per lavorare pesante e in sicurezza." },
      { t: "Area esterna", d: "Rig all'aperto per trazioni, finisher e allenamenti sotto il cielo di Lugano." },
    ],
    caption: "certificato. appeso al muro.",
  },
  interlude: { l1: "Il ferro", l2: "non mente.", sub: "Non ha opinioni, non ha giornate storte. Ti dice solo quanto vali oggi. E domani ti dà un'altra possibilità." },
  gallery: {
    kicker: "Cap. 03 — Galleria",
    title: "Dentro la Hammer",
    sub: "Foto vere, gente vera. Nessuna foto di repertorio.",
    captions: ["sotto lo sguardo di Arnold", "il padrone di casa", "il marchio", "la sala grande", "la famiglia Hammer"],
    igTitle: "Il diario di bordo",
    igText: "Allenamenti, PR, gare e vita di palestra. Ogni giorno.",
    igCta: "Seguici su Instagram",
    hint: "Tocca per ingrandire",
    close: "Chiudi",
  },
  pricing: {
    kicker: "Cap. 04 — Listino",
    title: "Scegli il tuo impegno.",
    sub: "I prezzi degli abbonamenti sono in aggiornamento. Passa in palestra o scrivici: ti diamo l'offerta su misura.",
    popular: "Il più scelto",
    free: "Gratis",
    onRequest: "Su richiesta",
    from: "da",
    cta: "Inizia da qui",
    ctaInfo: "Chiedi info su WhatsApp",
    student: "Studenti under 26",
    studentText: "-20% su tutti gli abbonamenti da 3, 6 e 12 mesi.",
    note: "* Prezzi indicativi, possono variare. Per gli abbonamenti chiedi in reception o su WhatsApp.",
    plans: {
      intro: { name: "Introduzione", period: "prima volta", desc: "Il primo allenamento lo offriamo noi.", features: ["1 allenamento di prova", "Tour della palestra", "Chiacchierata sui tuoi obiettivi"] },
      quarterly: { name: "Trimestrale", period: "3 mesi", desc: "Per partire forte.", features: ["Accesso illimitato 7/7, 06–22", "Macchine Hammer Strength e pesi liberi", "Scheda di allenamento iniziale", "Nessuno stop per vacanze", "Pagamento in un'unica soluzione"] },
      semiannual: { name: "Semestrale", period: "6 mesi", desc: "Il tempo giusto per vedere i risultati.", features: ["Accesso illimitato 7/7, 06–22", "Macchine Hammer Strength e pesi liberi", "Scheda di allenamento iniziale", "Fino a 15 giorni di stop per vacanze", "Pagamento ogni 3 mesi senza interessi"] },
      annual: { name: "Annuale", period: "12 mesi", desc: "Per chi è qui per restare.", features: ["Accesso illimitato 7/7, 06–22", "Macchine Hammer Strength e pesi liberi", "Scheda iniziale + aggiornamenti", "Fino a 15 giorni di stop per vacanze", "Pagamento ogni 3 mesi senza interessi"] },
      pt: { name: "Personal Training", period: "a sessione", desc: "Lavoro 1:1 con il coach, 45–60 minuti.", features: ["Programma costruito su di te", "Tecnica corretta, carichi giusti", "Massima flessibilità di orario"] },
      dropin: { name: "Drop-in", period: "ingresso singolo", desc: "Di passaggio a Lugano? Vieni ad allenarti.", features: ["Un allenamento, accesso completo", "CHF 20 per i minori di 18 anni"] },
    },
  },
  trial: {
    kicker: "Cap. 05 — Prova gratuita",
    title: "Il primo allenamento è su di noi.",
    sub: "Lasciaci i tuoi dati: ti richiamiamo per fissare giorno e ora. Nessun impegno.",
    stepsTitle: "Come funziona",
    steps: ["Compili il modulo (30 secondi).", "Ti richiamiamo e fissiamo giorno e ora.", "Vieni, ti alleni, decidi tu."],
    or: "Preferisci scriverci subito?",
    first: "Nome", last: "Cognome", phone: "Telefono", email: "Email (facoltativa)",
    goal: "Obiettivo", time: "Quando preferisci allenarti?", select: "Seleziona",
    goals: { mass: "Massa muscolare", cut: "Definizione", strength: "Forza", fitness: "Rimettermi in forma", comp: "Preparazione gara" },
    times: { morning: "Mattina (06–12)", afternoon: "Pomeriggio (12–18)", evening: "Sera (18–22)" },
    message: "Messaggio (facoltativo)", messagePh: "Esperienza, infortuni, domande...",
    consent: "Acconsento al trattamento dei miei dati per essere ricontattato da Hammer Gym.",
    submit: "Voglio la mia prova", sending: "Invio in corso...",
    successTitle: "Richiesta ricevuta!", successText: "Ti contattiamo a breve. Intanto prepara le scarpe.", again: "Invia un'altra richiesta",
    errRequired: "Compila almeno nome e telefono.", errConsent: "Serve il tuo consenso per ricontattarti.", errEmail: "Email non valida.", errGeneric: "Qualcosa è andato storto. Riprova o scrivici su WhatsApp.",
    toastOk: "Richiesta inviata. A presto in palestra!",
  },
  location: {
    kicker: "Cap. 06 — Dove siamo",
    title: "Vieni a trovarci.",
    hoursTitle: "Orari di apertura",
    days: ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"],
    today: "oggi",
    directions: "Indicazioni stradali",
    openMaps: "Apri in Google Maps",
    call: "Chiama ora",
    note: "Parcheggio nelle vicinanze. Sotto lo stesso tetto di CrossFit Lugano.",
  },
  footer: { previewTitle: "Anteprima di DoubleAstudio", preview: "Questo sito è un'anteprima realizzata da DoubleAstudio. Progetto, grafica, testi ed elaborazioni fotografiche sono di proprietà di DoubleAstudio e protetti dal diritto d'autore: è vietata qualsiasi copia, riproduzione o utilizzo, anche parziale, senza autorizzazione scritta.", rightsOwner: "DoubleAstudio", rightsFor: "Anteprima per Hammer Gym Studios Lugano.", tagline: "Old School Bodybuilding Gym — Est. 2011", rights: "Tutti i diritti riservati.", admin: "Area riservata", made: "Fatto a Lugano, col sudore.", backTop: "Torna su" },
  wa: {
    status: "di solito risponde in giornata",
    msg: "Ciao! Domande su abbonamenti, orari o prova gratuita? Scrivici: ti risponde una persona vera, non un bot.",
    cta: "Scrivi su WhatsApp",
    prefill: "Ciao Hammer Gym! Vorrei qualche informazione sulla palestra.",
    close: "Chiudi",
  },
  mobile: { call: "Chiama", wa: "WhatsApp", trial: "Prova gratis" },
};

const en = {
  meta: { title: "Hammer Gym Studios Lugano — Old School Bodybuilding Gym since 2011" },
  nav: { gym: "The gym", equipment: "Equipment", gallery: "Gallery", pricing: "Prices", contact: "Contact", trial: "Free trial", menu: "Menu" },
  hero: {
    eyebrow: "Hammer Gym Studios — Lugano",
    title: ["Old School", "Bodybuilding", "Gym."],
    sub: "Cast iron, sweat and Hammer Strength machines. Since 2011, Lugano's serious lifters train here. No frills: just you, the iron and the next rep.",
    ctaTrial: "Book your free trial",
    ctaPrices: "See prices",
    stamp: "EST. 2011 • VIA FOLA 13 • LUGANO • OLD SCHOOL • ",
    scroll: "Scroll",
    scribble: "no excuses.",
  },
  strip: { hoursLabel: "Hours", hours: "Mon–Sun · 06:00–22:00", addressLabel: "Address", callLabel: "Phone", igLabel: "Instagram", openNow: "Open now", closedNow: "Closed now" },
  band: ["NO EXCUSES", "OLD SCHOOL", "EST. 2011", "LIGHT WEIGHT, BABY!", "REAL IRON", "LUGANO"],
  about: {
    kicker: "Ch. 01 — The gym",
    title: "You don't come here to be seen. You come here to grow.",
    p1: "Hammer Gym Studios opened in 2011 as an old school bodybuilding gym: no selfie mirrors, no complicated memberships, no shortcuts. Just serious equipment and people who train for real.",
    p2: "We're Lugano's house of iron, under the same roof as CrossFit Lugano but with a soul of our own: the Golden Era. Beginner or competitor, you'll find space, respect and someone ready to spot your last rep.",
    stats: ["Founded", "Days a week", "Hours a day"],
    note: "Via Fola 13 — our second home",
    quote: "The last three or four reps is what makes the muscle grow.",
    quoteBy: "Arnold Schwarzenegger",
    prompt: "Heavy today. Heavier tomorrow.",
  },
  equipment: {
    kicker: "Ch. 02 — Equipment",
    title: "Official Hammer Strength Training Center",
    intro: "The plate-loaded machines that shaped bodybuilding history. Natural movement, real loads, no shortcuts.",
    items: [
      { t: "Hammer Strength plate-loaded", d: "Press, pull, legs: the red machines you know from legendary gyms." },
      { t: "Free weights", d: "Dumbbells, barbells, plates and benches. The foundation of everything." },
      { t: "Racks & strength area", d: "Squat, bench, deadlift. Room to go heavy, safely." },
      { t: "Outdoor area", d: "Outdoor rig for pull-ups, finishers and training under the Lugano sky." },
    ],
    caption: "certified. on the wall.",
  },
  interlude: { l1: "The iron", l2: "never lies.", sub: "It has no opinions and no bad days. It just tells you what you're worth today. And tomorrow it gives you another shot." },
  gallery: {
    kicker: "Ch. 03 — Gallery",
    title: "Inside the Hammer",
    sub: "Real photos, real people. No stock images.",
    captions: ["under Arnold's eyes", "the man of the house", "the badge", "the main floor", "the Hammer family"],
    igTitle: "The logbook",
    igText: "Workouts, PRs, competitions and gym life. Every day.",
    igCta: "Follow us on Instagram",
    hint: "Tap to enlarge",
    close: "Close",
  },
  pricing: {
    kicker: "Ch. 04 — Prices",
    title: "Choose your commitment.",
    sub: "Membership prices are being updated. Drop by or message us and we'll give you a tailored offer.",
    popular: "Most popular",
    free: "Free",
    onRequest: "On request",
    from: "from",
    cta: "Start here",
    ctaInfo: "Ask on WhatsApp",
    student: "Students under 26",
    studentText: "-20% on all 3, 6 and 12-month memberships.",
    note: "* Indicative prices, subject to change. For memberships ask at reception or on WhatsApp.",
    plans: {
      intro: { name: "Introduction", period: "first time", desc: "Your first workout is on us.", features: ["1 trial workout", "Gym tour", "A chat about your goals"] },
      quarterly: { name: "Quarterly", period: "3 months", desc: "To start strong.", features: ["Unlimited access 7/7, 06–22", "Hammer Strength machines & free weights", "Starter training plan", "No holiday pause", "Single payment"] },
      semiannual: { name: "Half-year", period: "6 months", desc: "The right time to see results.", features: ["Unlimited access 7/7, 06–22", "Hammer Strength machines & free weights", "Starter training plan", "Up to 15 days holiday pause", "Pay every 3 months, no interest"] },
      annual: { name: "Annual", period: "12 months", desc: "For those here to stay.", features: ["Unlimited access 7/7, 06–22", "Hammer Strength machines & free weights", "Starter plan + updates", "Up to 15 days holiday pause", "Pay every 3 months, no interest"] },
      pt: { name: "Personal Training", period: "per session", desc: "1:1 work with a coach, 45–60 minutes.", features: ["A program built around you", "Proper technique, right loads", "Maximum schedule flexibility"] },
      dropin: { name: "Drop-in", period: "single entry", desc: "Passing through Lugano? Come train.", features: ["One workout, full access", "CHF 20 for under 18s"] },
    },
  },
  trial: {
    kicker: "Ch. 05 — Free trial",
    title: "Your first workout is on us.",
    sub: "Leave your details: we'll call you back to set a day and time. No strings attached.",
    stepsTitle: "How it works",
    steps: ["Fill in the form (30 seconds).", "We call you and set a day and time.", "Come in, train, then decide."],
    or: "Rather message us right now?",
    first: "First name", last: "Last name", phone: "Phone", email: "Email (optional)",
    goal: "Goal", time: "When do you prefer to train?", select: "Select",
    goals: { mass: "Build muscle", cut: "Get lean", strength: "Strength", fitness: "Get back in shape", comp: "Contest prep" },
    times: { morning: "Morning (06–12)", afternoon: "Afternoon (12–18)", evening: "Evening (18–22)" },
    message: "Message (optional)", messagePh: "Experience, injuries, questions...",
    consent: "I agree to my data being processed so Hammer Gym can contact me.",
    submit: "I want my trial", sending: "Sending...",
    successTitle: "Request received!", successText: "We'll contact you soon. Get your shoes ready.", again: "Send another request",
    errRequired: "Please fill in at least name and phone.", errConsent: "We need your consent to contact you.", errEmail: "Invalid email.", errGeneric: "Something went wrong. Try again or message us on WhatsApp.",
    toastOk: "Request sent. See you at the gym!",
  },
  location: {
    kicker: "Ch. 06 — Find us",
    title: "Come and visit.",
    hoursTitle: "Opening hours",
    days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    today: "today",
    directions: "Get directions",
    openMaps: "Open in Google Maps",
    call: "Call now",
    note: "Parking nearby. Under the same roof as CrossFit Lugano.",
  },
  footer: { previewTitle: "Preview by DoubleAstudio", preview: "This website is a preview created by DoubleAstudio. Design, graphics, texts and photo editing are the property of DoubleAstudio and protected by copyright: any copying, reproduction or use, even partial, without written permission is prohibited.", rightsOwner: "DoubleAstudio", rightsFor: "Preview for Hammer Gym Studios Lugano.", tagline: "Old School Bodybuilding Gym — Est. 2011", rights: "All rights reserved.", admin: "Staff area", made: "Made in Lugano, with sweat.", backTop: "Back to top" },
  wa: {
    status: "usually replies the same day",
    msg: "Hi! Questions about memberships, hours or the free trial? Message us: a real person will reply, not a bot.",
    cta: "Chat on WhatsApp",
    prefill: "Hi Hammer Gym! I'd like some information about the gym.",
    close: "Close",
  },
  mobile: { call: "Call", wa: "WhatsApp", trial: "Free trial" },
};

const de = {
  meta: { title: "Hammer Gym Studios Lugano — Old-School-Bodybuilding-Gym seit 2011" },
  nav: { gym: "Das Gym", equipment: "Ausstattung", gallery: "Galerie", pricing: "Preise", contact: "Kontakt", trial: "Probetraining", menu: "Menü" },
  hero: {
    eyebrow: "Hammer Gym Studios — Lugano",
    title: ["Old School", "Bodybuilding", "Gym."],
    sub: "Gusseisen, Schweiss und Hammer-Strength-Maschinen. Seit 2011 trainiert hier, wer es in Lugano ernst meint. Kein Schnickschnack: nur du, das Eisen und die nächste Wiederholung.",
    ctaTrial: "Gratis Probetraining buchen",
    ctaPrices: "Preise ansehen",
    stamp: "SEIT 2011 • VIA FOLA 13 • LUGANO • OLD SCHOOL • ",
    scroll: "Scrollen",
    scribble: "keine ausreden.",
  },
  strip: { hoursLabel: "Öffnungszeiten", hours: "Mo–So · 06:00–22:00", addressLabel: "Adresse", callLabel: "Telefon", igLabel: "Instagram", openNow: "Jetzt geöffnet", closedNow: "Jetzt geschlossen" },
  band: ["KEINE AUSREDEN", "OLD SCHOOL", "SEIT 2011", "LIGHT WEIGHT, BABY!", "ECHTES EISEN", "LUGANO"],
  about: {
    kicker: "Kap. 01 — Das Gym",
    title: "Hier kommt man nicht, um gesehen zu werden. Sondern um zu wachsen.",
    p1: "Hammer Gym Studios wurde 2011 als Bodybuilding-Gym alter Schule gegründet: keine Selfie-Spiegel, keine komplizierten Abos, keine Abkürzungen. Nur ernsthafte Geräte und Leute, die wirklich trainieren.",
    p2: "Wir sind Luganos Haus des Eisens, unter einem Dach mit CrossFit Lugano, aber mit eigener Seele: der des Golden Age. Ob Anfänger oder Wettkampfathlet, hier findest du Platz, Respekt und jemanden, der dir bei der letzten Wiederholung hilft.",
    stats: ["Gründungsjahr", "Tage pro Woche", "Stunden am Tag"],
    note: "Via Fola 13 — unser zweites Zuhause",
    quote: "Die letzten drei oder vier Wiederholungen lassen den Muskel wachsen.",
    quoteBy: "Arnold Schwarzenegger",
    prompt: "Heute schwer. Morgen schwerer.",
  },
  equipment: {
    kicker: "Kap. 02 — Ausstattung",
    title: "Official Hammer Strength Training Center",
    intro: "Die Plate-Loaded-Maschinen, die Bodybuilding-Geschichte geschrieben haben. Natürliche Bewegungen, echte Gewichte, keine Abkürzungen.",
    items: [
      { t: "Hammer Strength Plate-Loaded", d: "Drücken, Ziehen, Beine: die roten Maschinen aus den legendären Gyms." },
      { t: "Freie Gewichte", d: "Kurzhanteln, Langhanteln, Scheiben und Bänke. Die Basis von allem." },
      { t: "Racks & Kraftbereich", d: "Kniebeugen, Bankdrücken, Kreuzheben. Platz, um schwer und sicher zu trainieren." },
      { t: "Aussenbereich", d: "Outdoor-Rig für Klimmzüge, Finisher und Training unter dem Himmel von Lugano." },
    ],
    caption: "zertifiziert. an der wand.",
  },
  interlude: { l1: "Das Eisen", l2: "lügt nie.", sub: "Es hat keine Meinung und keine schlechten Tage. Es sagt dir nur, was du heute wert bist. Und morgen gibt es dir eine neue Chance." },
  gallery: {
    kicker: "Kap. 03 — Galerie",
    title: "Im Hammer",
    sub: "Echte Fotos, echte Leute. Keine Stockbilder.",
    captions: ["unter Arnolds Blick", "der Hausherr", "das Abzeichen", "die grosse Halle", "die Hammer-Familie"],
    igTitle: "Das Logbuch",
    igText: "Trainings, PRs, Wettkämpfe und Gym-Leben. Jeden Tag.",
    igCta: "Folge uns auf Instagram",
    hint: "Zum Vergrössern tippen",
    close: "Schliessen",
  },
  pricing: {
    kicker: "Kap. 04 — Preise",
    title: "Wähle dein Commitment.",
    sub: "Die Abopreise werden gerade aktualisiert. Komm vorbei oder schreib uns für ein individuelles Angebot.",
    popular: "Am beliebtesten",
    free: "Gratis",
    onRequest: "Auf Anfrage",
    from: "ab",
    cta: "Hier starten",
    ctaInfo: "Auf WhatsApp fragen",
    student: "Studierende unter 26",
    studentText: "-20% auf alle 3-, 6- und 12-Monats-Abos.",
    note: "* Richtpreise, Änderungen vorbehalten. Für Abos frag an der Rezeption oder auf WhatsApp.",
    plans: {
      intro: { name: "Einführung", period: "erstes Mal", desc: "Das erste Training geht auf uns.", features: ["1 Probetraining", "Rundgang durchs Gym", "Gespräch über deine Ziele"] },
      quarterly: { name: "3 Monate", period: "3 Monate", desc: "Für einen starken Start.", features: ["Unbegrenzter Zugang 7/7, 06–22", "Hammer-Strength-Maschinen & freie Gewichte", "Einstiegs-Trainingsplan", "Keine Ferienpause", "Einmalzahlung"] },
      semiannual: { name: "6 Monate", period: "6 Monate", desc: "Genug Zeit, um Ergebnisse zu sehen.", features: ["Unbegrenzter Zugang 7/7, 06–22", "Hammer-Strength-Maschinen & freie Gewichte", "Einstiegs-Trainingsplan", "Bis zu 15 Tage Ferienpause", "Zahlung alle 3 Monate, zinsfrei"] },
      annual: { name: "Jahresabo", period: "12 Monate", desc: "Für alle, die bleiben wollen.", features: ["Unbegrenzter Zugang 7/7, 06–22", "Hammer-Strength-Maschinen & freie Gewichte", "Einstiegsplan + Updates", "Bis zu 15 Tage Ferienpause", "Zahlung alle 3 Monate, zinsfrei"] },
      pt: { name: "Personal Training", period: "pro Einheit", desc: "1:1 mit dem Coach, 45–60 Minuten.", features: ["Ein Programm nur für dich", "Saubere Technik, richtige Gewichte", "Maximale zeitliche Flexibilität"] },
      dropin: { name: "Drop-in", period: "Einzeleintritt", desc: "Auf der Durchreise in Lugano? Komm trainieren.", features: ["Ein Training, voller Zugang", "CHF 20 für unter 18-Jährige"] },
    },
  },
  trial: {
    kicker: "Kap. 05 — Probetraining",
    title: "Das erste Training geht auf uns.",
    sub: "Hinterlasse deine Daten: Wir rufen dich zurück, um Tag und Uhrzeit festzulegen. Unverbindlich.",
    stepsTitle: "So funktioniert's",
    steps: ["Formular ausfüllen (30 Sekunden).", "Wir rufen dich an und legen einen Termin fest.", "Komm vorbei, trainiere, entscheide selbst."],
    or: "Lieber gleich schreiben?",
    first: "Vorname", last: "Nachname", phone: "Telefon", email: "E-Mail (optional)",
    goal: "Ziel", time: "Wann trainierst du am liebsten?", select: "Auswählen",
    goals: { mass: "Muskelaufbau", cut: "Definition", strength: "Kraft", fitness: "Wieder fit werden", comp: "Wettkampfvorbereitung" },
    times: { morning: "Morgens (06–12)", afternoon: "Nachmittags (12–18)", evening: "Abends (18–22)" },
    message: "Nachricht (optional)", messagePh: "Erfahrung, Verletzungen, Fragen...",
    consent: "Ich bin einverstanden, dass meine Daten verarbeitet werden, damit Hammer Gym mich kontaktieren kann.",
    submit: "Ich will mein Probetraining", sending: "Wird gesendet...",
    successTitle: "Anfrage erhalten!", successText: "Wir melden uns bald. Mach schon mal die Schuhe bereit.", again: "Weitere Anfrage senden",
    errRequired: "Bitte mindestens Name und Telefon ausfüllen.", errConsent: "Wir brauchen deine Zustimmung, um dich zu kontaktieren.", errEmail: "Ungültige E-Mail.", errGeneric: "Etwas ist schiefgelaufen. Versuch es nochmal oder schreib uns auf WhatsApp.",
    toastOk: "Anfrage gesendet. Bis bald im Gym!",
  },
  location: {
    kicker: "Kap. 06 — Anfahrt",
    title: "Komm vorbei.",
    hoursTitle: "Öffnungszeiten",
    days: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
    today: "heute",
    directions: "Route planen",
    openMaps: "In Google Maps öffnen",
    call: "Jetzt anrufen",
    note: "Parkplätze in der Nähe. Unter einem Dach mit CrossFit Lugano.",
  },
  footer: { previewTitle: "Vorschau von DoubleAstudio", preview: "Diese Website ist eine Vorschau von DoubleAstudio. Design, Grafik, Texte und Bildbearbeitung sind Eigentum von DoubleAstudio und urheberrechtlich geschützt: Jede auch teilweise Kopie, Vervielfältigung oder Nutzung ohne schriftliche Genehmigung ist untersagt.", rightsOwner: "DoubleAstudio", rightsFor: "Vorschau für Hammer Gym Studios Lugano.", tagline: "Old-School-Bodybuilding-Gym — Seit 2011", rights: "Alle Rechte vorbehalten.", admin: "Interner Bereich", made: "Gemacht in Lugano, mit Schweiss.", backTop: "Nach oben" },
  wa: {
    status: "antwortet meist am selben Tag",
    msg: "Hallo! Fragen zu Abos, Öffnungszeiten oder Probetraining? Schreib uns: Es antwortet ein echter Mensch, kein Bot.",
    cta: "Auf WhatsApp schreiben",
    prefill: "Hallo Hammer Gym! Ich hätte gerne Informationen zum Gym.",
    close: "Schliessen",
  },
  mobile: { call: "Anrufen", wa: "WhatsApp", trial: "Probetraining" },
};

export const TRANSLATIONS = { it, en, de };
